// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"c134d2a9","161":"cbfa33ed","215":"4afa0f88","313":"9662e52e","787":"968fb227","814":"42d38c03"}[chunkId] + ".chunk.js";
};